import { axiosInstance } from './httpClient';
import { API } from './env';

export default class WhatsappOptOutsApi {
  static getAuthConfig = () => {
    const userInfo = JSON.parse(localStorage.getItem('user'));
    const accessToken = userInfo.token;
    return {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + accessToken,
      },
    };
  };

  static getAll = ({ search, source, fromDate, toDate, limit, offset } = {}) => {
    const params = new URLSearchParams();
    if (search) params.set('search', search);
    if (source && source !== 'ALL') params.set('source', source);
    if (fromDate) params.set('fromDate', fromDate);
    if (toDate) params.set('toDate', toDate);
    if (limit != null) params.set('limit', String(limit));
    if (offset != null) params.set('offset', String(offset));
    const qs = params.toString();
    return axiosInstance.get(
      `${API}/admin/messaging/opt-outs${qs ? `?${qs}` : ''}`,
      this.getAuthConfig()
    );
  };

  static create = ({ phoneNumber, reason }) => {
    return axiosInstance.post(
      `${API}/admin/messaging/opt-outs`,
      JSON.stringify({ phoneNumber, reason }),
      this.getAuthConfig()
    );
  };

  static remove = ({ phoneNumber }) => {
    return axiosInstance.post(
      `${API}/admin/messaging/opt-outs/remove`,
      JSON.stringify({ phoneNumber }),
      this.getAuthConfig()
    );
  };
}
